export default __webpack_public_path__ + "static/media/app-store.5bd3be20.png";